<div class="p-4 flex-col flex gap-4">
    <!-- Header -->
    <div class="flex flex-col gap-1">
        <h3>
            <i class="pi pi-desktop text-blue-700"></i> 會議室使用狀態
        </h3>
    </div>

    <!-- Scope Select -->
    <div class="w-full">
        <p-selectButton unselectable [options]="scopeOptions" [ngModel]="selectedScope()"
            (ngModelChange)="selectedScope.set($event)" optionLabel="label" optionValue="value"
            styleClass="w-full grid grid-cols-2" [style]="{'width':'100%'}">
        </p-selectButton>
    </div>

    <!-- Status Cards Container -->
    <div class="flex flex-col gap-3">
        <!-- Reserved (Amber) -->
        <div
            class="bg-amber-50 rounded-lg p-3 shadow-sm border border-amber-300 flex justify-between items-center h-[56px]">
            <div class="flex items-center gap-2 text-slate-700">
                <i class="pi pi-calendar text-amber-600"></i>
                <span class="text-sm">預約中</span>
            </div>
            <div class="font-bold text-2xl text-amber-600 flex items-baseline gap-1">
                {{ stats().reserved.count }}/{{ stats().reserved.total }}
                <span class="text-sm font-normal text-slate-500">間</span>
            </div>
        </div>

        <!-- Idle (Slate/White) -->
        <div
            class="bg-white rounded-lg p-3 shadow-sm border border-slate-200 flex justify-between items-center h-[56px]">
            <div class="flex items-center gap-2 text-slate-600">
                <i class="ci ci-door text-slate-500"></i>
                <span class="text-sm">閒置中</span>
            </div>
            <div class="font-bold text-2xl text-slate-600 flex items-baseline gap-1">
                {{ stats().idle.count }}/{{ stats().idle.total }}
                <span class="text-sm font-normal text-slate-500">間</span>
            </div>
        </div>

        <!-- In Use (Green) -->
        <div
            class="bg-green-50 rounded-lg p-3 shadow-sm border border-green-600 flex justify-between items-center h-[56px]">
            <div class="flex items-center gap-2 text-slate-700">
                <i class="pi pi-clock text-green-700"></i>
                <span class="text-sm font-bold">使用中</span>
            </div>
            <div class="font-bold text-2xl text-slate-600 flex items-baseline gap-1">
                {{ stats().inUse.count }}/{{ stats().inUse.total }}
                <span class="text-sm font-normal text-slate-500">間</span>
            </div>
        </div>
    </div>
</div>